/**
 * Canonical guest share route (opaque token). Matches backend `build_public_share_page_url`.
 * Spec: kb/specs/app/system/permissions-and-sharing.md
 */
export const PUBLIC_SHARE_ROUTE = "/share/:token";

/** @param {string} token Raw token segment (path may encode it) */
export function publicSharePagePath(token) {
  return `/share/${encodeURIComponent(token)}`;
}
